import _ from "lodash";
import * as React from "react";
import { FormComponent } from "../../../react-core/Html/FormComponent";
import { DragSort } from "../DragSort/DragSort";
import { ITableConfig } from "../Table/Table";
import { TableColSettingsAction } from "./Action/Action";
import { defaultTableColEditor } from "./Resource/Content";
import { TableColSettingsStore } from "./Store/Variable";

export interface ITableColFilterProps {
    onApply: VoidFunction;
    onCancel: VoidFunction;
    tableKey: string;
    col: ITableConfig[];
    disableDrag?: boolean;
}

export interface ITableColFilterState {
    originSetting: any[];
    currentSettings: any[];
}

export class TableColFilter extends FormComponent<ITableColFilterProps, ITableColFilterState> {
    constructor(props: any) {
        super(props);

        this.state = {
            originSetting: [],
            currentSettings: [],
        };
        this.subscribeToStore(TableColSettingsStore, () => this.onTableColSettingsStoreChange());
    }

    componentDidMount() {
        this.getSettings();
    }

    private onTableColSettingsStoreChange() {
        this.getSettings();
    }

    private getSettings() {
        const { tableKey } = this.props;
        if (!tableKey) {return;}
        const _settings = JSON.parse(JSON.stringify(TableColSettingsStore.getData()));
        if (!_settings) {
            TableColSettingsAction.get(tableKey);
        } else if (JSON.stringify(_settings) == "{}") {
            TableColSettingsAction.post(defaultTableColEditor);
        } else if (!_settings[tableKey]) {
            TableColSettingsAction.post(defaultTableColEditor[tableKey], tableKey);
        } else {
            this.setState({
                currentSettings: _settings[tableKey],
                originSetting: _.uniqBy(_settings[tableKey], "Column"),
            });
        }
    }

    private onSelectCol(col) {
        const _data = this.state.currentSettings.concat();
        const i = _data.findIndex((ele) => ele.Column == col);
        _data[i].Enabled = !_data[i].Enabled;
        this.setState({ currentSettings: _data });
    }

    public render(): JSX.Element {
        const { originSetting, currentSettings } = this.state;
        return (
            <div>
                <p className="text-size-16 text-bold mb-10">Table editor</p>
                <p className="text-size-12 text-bold mb-10">Please select which column headers to display</p>
                <ul className="filter-options">
                    <DragSort
                        data={originSetting}
                        onReOrder={(v) => this.setState({ currentSettings: v })}
                        disableDrag={this.props.disableDrag}
                    >
                        {originSetting.map((item, index) => {
                            const _col = this.props.col.find((ele) => ele.tableFilter == item.Column);
                            const isChecked = currentSettings.find((ele) => ele.Column == item.Column).Enabled;
                            const disableEdit = _col?.filterOption?.disableEdit;
                            console.log(isChecked)
                            if (disableEdit)
                                {return (
                                    <li>
                                        <label className="filter-option">
                                            <input type="checkbox" disabled={true} />
                                            <span className="label">
                                                <span className="label-inner">{_col?.filterTitle || _col?.title}</span>
                                            </span>
                                        </label>
                                    </li>
                                );}
                            return (
                                <li 
                                >
                                    <label
                                        className="filter-option"
                                        htmlFor={'id-' + item.Column}
                                    >
                                        <input type="checkbox" checked={isChecked} id={'id-' + item.Column} onChange={() => {
                                        this.onSelectCol(item.Column);
                                    }}/>
                                        <span className="label">
                                            <span className="label-inner">{_col?.filterTitle || _col?.title}</span>
                                        </span>
                                    </label>
                                </li>
                            );
                        })}
                    </DragSort>
                </ul>
                <br />
                <div className="row narrow-gutter">
                    <div className="col-auto col-middle" onClick={() => this.onResetClick()}>
                        <button className="hyperlink">Apply default</button>
                    </div>
                    <div className="col-fluid text-right" onClick={() => this.onCancelClick()}>
                        <button className="btn secondary block-xxs">Cancel</button>
                    </div>
                    <div className="col-auto" onClick={() => this.onApplyClick()}>
                        <button className="btn primary block-xxs">Apply</button>
                    </div>
                </div>
            </div>
        );
    }

    private onCancelClick() {
        this.props.onCancel();
    }

    private onApplyClick() {
        const { tableKey } = this.props;
        TableColSettingsAction.post(this.state.currentSettings, tableKey);
        this.props.onApply();
    }

    private onResetClick() {
        const { tableKey } = this.props;
        TableColSettingsAction.post(defaultTableColEditor[tableKey], tableKey);
        this.props.onApply();
    }
}
